import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Toast from '../../commons/helpers/toast';
import * as types from '../../../actions';

import {LBL_APP_NAME, LBL_SETTINGS, LBL_PP_POINTS,LBL_BACK_TO_SETTINGS} from '../../../configs/labelConfigs'; 
import {ROUTE_REFRESH,ROUTE_SA_SETTINGS} from '../../../configs/staticConfigs';
import {MSG_PP_POINTS_SUCCESS,MSG_OMNU_ERROR, MSG_DECIMAL_NUM_ERROR} from '../../../configs/msgConfigs';
import {pointsListAction, pointsSaveAction} from '../../../actions/settings/superadmin/omnuPointsActions';
import {clearAction} from '../../../actions/commonActions';

import {checkNum} from '../../../utils/validation';

class OMNUPointsComponent extends Component { 

    constructor(props) {
        super(props);
        this.state = {
            pointsList : [],           
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            isButtonActive:1,        
        }   
        this.onHandleChange = this.onHandleChange.bind(this);  
        this.saveFormData   = this.saveFormData.bind(this);

    }

    onHandleChange = (e) => {
        let {name, value} = e.target;  
        if(checkNum(value.trim())){
            this.setState({
                isButtonActive:1
            });
        }else{
            value = ''; 
        } 

        if(value.trim()=='' || value.trim()=='-'){
            this.setState({
                isButtonActive:0
            });
        } 

        this.setState((prevState) => ({
            pointsList: prevState.pointsList.map(
                el => el.id === Number(name)? { ...el, points: value.trim()}: el
            )
        }));      
    };    

    saveFormData = (e) =>{
        e.preventDefault();
        const { pointsList,isButtonActive } = this.state; 
        if(isButtonActive){
            this.props.pointsSaveAction(pointsList);
        } 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    setStateUpdate(status,activity){
        if( activity===types.OMNU_POINTS_LIST_SUCCESS){
            this.setState({pointsList:this.props.omnuPoints});
        }else if(activity===types.OMNU_POINTS_SAVE_SUCCESS){
            this.setToasterState(true,MSG_PP_POINTS_SUCCESS,true);
        }else if(activity===types.OMNU_POINTS_SAVE_ERROR){
            if(status===400){
                this.setToasterState(true,MSG_OMNU_ERROR,false);  
            }else{
                this.setToasterState(true,MSG_DECIMAL_NUM_ERROR,false);  
            }
        }
    }    

    componentDidUpdate(prevProps) {   
        const { status,activity} = this.props;

        if (activity !== prevProps.activity) {
            this.setStateUpdate(status,activity);
            this.props.clearAction();
        }
    }

    componentDidMount() {
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+' - '+LBL_PP_POINTS;
        this.props.pointsListAction();
    }

    render(){
        const { pointsList, toastMessage,toastFlag,toastSuccess,isButtonActive } = this.state;    
        
        if(this.props.status===401  || this.props.status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        return(
            <div className="col-md-4">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <form onSubmit={this.saveFormData}>
                                <table id="data-table" className="table" style={{width:"100%"}} >
                                    <thead>
                                        <tr>
                                            <th className="text-center">{LBL_PP_POINTS}</th>
                                            <th className="text-center">Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { pointsList.map(item => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{item.parameter_name}</td>
                                                <td className="text-center">
                                                    <div className="form-group">
                                                        <div className="text-input"><input type="text" name={item.id} key={item.id} defaultValue={item.points} onChange={this.onHandleChange} maxLength = {4} className={item.points.toString().length>0 ? "" : 'input-error'} value={item.points}  /></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                        })
                                        }                                 
                                        <tr className="border-none">
                                            <td>
                                                <span className={isButtonActive?'hide':'text-red'}>{MSG_OMNU_ERROR}</span>
                                            </td>
                                            <td className="text-right">
                                                <button type="submit" className="btn btn-primary">Save</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
        
    }
    
}

const mapStateToProps = (state) => {
    return {
        omnuPoints : state.omnuPoints.items,       
        status:state.omnuPoints.status,
        activity:state.omnuPoints.activity
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        pointsListAction:pointsListAction,  
        pointsSaveAction:data=>pointsSaveAction(data),
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(OMNUPointsComponent);